import React from "react";

// `min`/`max` keep the year inside a range that can actually be a pregnancy, and
// incidentally put the 275760-09-13 overflow that crashed date-fns out of reach.
const MIN_DATE = "2000-01-01";
const MAX_DATE = "2035-12-31";

export default function InputDate({ inputDate, handleInputDateChange, label, hint }) {
    return (
        <div>
            {/* Was sr-only. Session recordings show repeated clicks on this field with
                nothing entered: on desktop it renders as a bare "jj/mm/aaaa" with no
                visible indication of which date is being asked for. */}
            <label htmlFor="inputDate" className="block text-sm sm:text-base mb-2 font-semibold text-gray-900">
                {label}
            </label>
            <input
                type="date"
                value={inputDate || ""}
                onChange={handleInputDateChange}
                min={MIN_DATE}
                max={MAX_DATE}
                className="dropdown min-w-32 sm:max-w-56"
                id="inputDate"
                name="inputDate"
                aria-label={label}
                title={label}
                aria-describedby="inputDate-hint"
                aria-required="true"
            ></input>
            <p id="inputDate-hint" className="text-xs text-gray-600 mt-2">{hint}</p>
        </div>
    )
}
